<template>
  <div class="max-w-3xl">
    <div
      id="intro-text"
      class="text-5xl md:text-7xl uppercase font-black leading-none"
    >
      <span class="text-red-600">Thank you</span> for taking part in this survey
    </div>
    <div class="text-2xl mt-10">
      Your answers will help to build a healthier, more active community
    </div>
    <div
      v-for="(survey, surveyIndex) in surveys"
      :key="surveyIndex"
    >
      <router-link
        :to="{ name: 'survey_hash', params: { survey_hash: survey.hash }}"
        class="mt-10 flex justify-between items-center w-full sm:w-72 md:w-80 text-left border-4 border-white p-3 my-2 text-2xl font-bold font-display leading-tight focus:outline-none focus:border-orange-700"
      >
        <span class="flex-1 mr-2">{{ survey.text }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 22 22"
          class="w-8 h-8"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            d="M1 1h20v20H1z"
          />
          <path
            fill="currentColor"
            d="M11.2 5c.3-.3.7-.3.9 0l5.3 5.3c.3.3.3.7 0 .9l-5.3 5.3c-.3.3-.7.3-.9 0l-.6-.6c-.3-.3-.3-.7 0-.9l3.3-3.1H6c-.4 0-.7-.3-.7-.7v-.9c0-.4.3-.7.7-.7h7.9l-3.3-3.1c-.3-.3-.3-.7 0-.9l.6-.6z"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      surveys: 'surveys',
      directions: 'survey/directions'
    })
  },
  mounted () {
    this.$store.dispatch('getSurveys')
    this.$store.commit('survey/CURRENT_DIRECTION_UPDATED', this.directions.NEXT)
  }
}
</script>
